<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('read','affiliates')"
            variant="info"
            :disabled="excelSpinner"
            @click="downloadExcel"
          >
            <b-spinner
              v-if="excelSpinner"
              small
            />
            {{ $t('Download excel') }}
            <feather-icon icon="FileTextIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <affiliates-list
      v-else
      :fields="fields"
      :items="items"
      :sort-key="sortKey"
      :sort-type="sortType"
      :additional-data="additionalData"
      :list-filters="additionalData.filters"
      :filters="filters"
      @onSortByChange="changeSortKey"
      @onSortDescChange="changeSortType"
      @onFilterChange="filterChange"
      @onFilterButtonClicked="getData"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import AffiliatesList from '../../components/affiliates/list/AffiliatesList'

export default {
  components: {
    AffiliatesList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'affiliates',
      userFields: [
        {
          key: 'payment.user',
          label: this.$t('User'),
        },
        {
          key: 'percent',
          label: this.$t('Percent'),
        },
        {
          key: 'amount',
          label: this.$t('Amount'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'created_at',
          label: this.$t('Created at'),
        },
      ],
      adminFields: [
        {
          key: 'user',
          label: this.$t('User'),
        },
        {
          key: 'type',
          label: this.$t('Type'),
        },
        {
          key: 'percent',
          label: this.$t('Percent'),
        },
        {
          key: 'amount',
          label: this.$t('Amount'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'created_at',
          label: this.$t('Created at'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
  created() {
    if (this.$route.name === 'profile' || this.$route.name === 'users-show') {
      this.customParams.type = 'affiliate'
    }
    if (this.$route.name === 'users-show') {
      this.customParams.user_id = this.$route.params.id
    }
  },
}
</script>

<style lang="scss">

</style>
